<template>

    <div
        class="divide-y divide-gray-200 website::admin-websitePages-createEdit-moduleEditor-websitPageBlock-Options"
        :class="{ saving }">

        <Toolbar
            title="Module configureren"
            instruction="Configueer hier de module voor deze pagina."/>

        <div class="flex px-5 py-10 sm:px-10">

            <div class="w-1/3 overflow-hidden bg-white shadow sm:rounded-lg">

                <div class="flex items-center px-4 py-5 text-lg font-bold border-b sm:px-6">
                    <div class="my-0 user-img">
                        <span class="round bg-primary"><i
                            :class="currentModule.meta.icon"></i>
                        </span>
                    </div>
                    <h2 class="m-0 ml-3 card-title">{{ currentModule.meta.name }}</h2>
                </div>

                <div class="px-4 py-5 sm:px-6">
                    <read-more more-str="Lees verder" :text="currentModule.meta.description" link="#"
                               less-str="Lees minder" :max-chars="250"
                    ></read-more>
                </div>

            </div>

            <div class="relative w-2/3 pl-10">
                <div class="loader"
                     v-if="configurable && inputsRender === null"
                >

                    <HalfCircleSpinner
                        :size="30"
                        color="#ddd"
                        class="mt-4 mb-2"/>

                </div>

                <div v-if="configurable" ref="inputsRender" class="inputsRender" v-html="inputsRender">
                    <!-- Will lead to redraws if any data on this is updated.
                        <v-runtime-template :template="inputsRender" />
                    -->
                </div>

                <div v-else>
                    <div class="self-start p-4 rounded-md bg-blue-50">
                        <div class="flex">
                            <div class="flex-shrink-0">
                                <svg class="w-5 h-5 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                     fill="currentColor" aria-hidden="true">
                                    <path fill-rule="evenodd"
                                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                          clip-rule="evenodd"/>
                                </svg>
                            </div>
                            <div class="flex-1 ml-3 md:flex md:justify-between">
                                <p class="text-sm text-blue-700">
                                    Deze module is niet te configureren. U kunt gelijk op "Opslaan" klikken.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="flex justify-between px-5 py-10 sm:px-10">

            <button
                type="button"
                class="btn btn-info"
                @click="clearModule"
                :disabled="configurable && saving">
                <i class="mr-2 fas fa-times"></i>
                Kies andere module
            </button>

            <HalfCircleSpinner
                v-if="saving"
                :size="30"
                color="#ddd"
                class="inline-block float-right mt-1 ml-4 mr-4"/>

            <button v-if="!saving" type="button" class="btn btn-success" @click="save">
                <i class="mr-2 fas fa-check"></i>
                Opslaan
            </button>

        </div>

    </div>

</template>

<script>

import VRuntimeTemplate from "v-runtime-template";
import loadJs from 'load-js';
import Toolbar from './Toolbar';
import mountVues from "@galaxy/modules/Core/resources/js/mountVues";

export default {

    components: {
        VRuntimeTemplate,
        Toolbar,
    },

    props: {
        websitePage: Object,
        modulesData: Object,
    },

    data() {
        return {
            inputsRender: null,
            saving: false
        }
    },

    mounted() {
        // Load data due to configurable?
        if (this.configurable)
            this.loadOptionsHtml();

    },

    methods: {

        async loadOptionsHtml() {
            // Set as loading.
            this.inputsRender = null;

            // Request
            var inputsRender = await $.get(this.routeBaseUrl, {
                language: this.language,
                moduleId: this.websitePage.module_id,
            });

            // Get new JSes, which arent loaded in the <head> yet.
            let newScripts = this.extractInputRenderNewScripts(inputsRender);

            // Load new script urls.
            loadJs(newScripts.urls)
                .then(async () => {
                    // Render
                    this.inputsRender = inputsRender;

                    // Execute inline JSes.
                    _.each(newScripts.inlines, script => eval(script));

                    // Wait for HTML rendering.
                    await this.$nextTick();

                    this.onLoaded();
                });
        },

        // TODO Code duplication with moduleEditor/Options.vue
        extractInputRenderNewScripts(inputsRender) {
            let result = {
                urls: [],
                inlines: []
            };

            // Get existing scripts.
            var existingUrls = _.map($('script[src]'), script => script.getAttribute('src'));

            // TODO Execute scripts in order.
            // Loop scripts.
            $('script', $('<div />').append(inputsRender))
                .each((i, script) => {
                    // Add as inline?
                    if (script.innerHTML)
                        result.inlines.push(script.innerHTML);

                    // Add as src?
                    else {
                        // Get script src.
                        let src = $(script).attr('src');

                        // Add as url?
                        if (existingUrls.indexOf(src) == -1)
                            result.urls.push(src);
                    }
                });

                    return result;
        },

        onLoaded() {
            // Wait for DOM.
            common.View.reinit();

            // Re init vue as well just to be sure.
            mountVues('body');
        },

        clearModule() {
            this.$emit('clearModule');
        },

        async save() {
            // Set as saving.
            this.saving = true;

            // Save
            let response = await $.ajax({
                // Removed &language=' + this.language + ' from url because it's not implemented
                url: this.routeBaseUrl + '?_method=put&moduleId=' + this.websitePage.module_id,
                type: 'POST',
                dataType: 'html',
                data: this.getSaveData(),
                processData: false,
                contentType: false,
            });

            // Is save with HTML response - probably validation errors?
            if (this.configurable && response)
                this.onSaveHtml(response);

            // Is saved?
            else
                this.onSaved();
        },

        async onSaveHtml(response) {
            // Set response.
            this.inputsRender = response;

            // Wait for HTML rendering.
            await this.$nextTick();

            // Scroll to top.
            $(this.$refs['inputsRender'])
                .animate({
                    scrollTop: 0
                }, 'slow');

                    common.View.reinit();

            // Set as saved.
            this.saving = false;
        },

        onSaved() {
            // Set as saved.
            this.saving = false;

            // Notify user.
            this.$toasted.show('De module is succesvol bewaard!', {
                theme: 'bootstrap-success',
                action: {
                    text: 'Bekijk resultaat',
                    onClick: this.viewResult
                },
            });
        },

        getSaveData() {
            // Init form data.
            let formElement = $('form', this.$refs['inputsRender']);

            return new FormData(formElement.get(0));
        },

        // TODO Fix code duplication with content editor?
        viewResult() {
            let url = '';

            /* TODO Implement multilanguage support.
            // Prepend with language?
            if(this.languages.length > 1)
                url = '/' + this.language;
             */

            // Add slug.
            url += '/' + this.websitePage.slug['nl']; //this.language];

            // Open in new window.
            window.open(url);
        },
    },

    computed: {

        routeBaseUrl() {
            // Loose last part of url
            let pieces = document.location.pathname.split('/');

            // Pop pieces
            pieces.pop();

                    return pieces.join('/') + '/module-options';
        },

        currentModule() {
            return this.modulesData[this.websitePage.module_id];
        },

        configurable() {
            return this.currentModule.configurable;
        },

    }

}

</script>

<style lang="scss">

.website\:\:admin-websitePages-createEdit-moduleEditor-websitPageBlock-Options {

    &.saving {
        cursor: wait;

        .form-group {
            opacity:        .5;
            pointer-events: none;
        }
    }

    .loader {
        left:     calc(50% - 30px / 2);
        position: absolute;
        top:      calc(50% - 30px / 2);
        z-index:  100;
    }

    .meta {
        border-bottom: 1px solid #eee;
    }

    #readmore {
        @apply bg-indigo-50 px-2 py-1 inline-block rounded mt-2 text-gray-800;
    }

    > .actions {
        border-top:  1px solid #eee;
        flex-shrink: 0;
    }
}

</style>
